import { render, staticRenderFns } from "./helpSeting.vue?vue&type=template&id=01f73636&scoped=true"
import script from "./helpSeting.vue?vue&type=script&lang=js"
export * from "./helpSeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f73636",
  null
  
)

export default component.exports